<template>
  <div>
    <el-form :inline="true" style="margin-left: 0; margin-bottom: 10px;">
      <el-form-item>
        <el-input
          v-model="plateNumber"
          placeholder="请输入车牌"
        ></el-input>
      </el-form-item>
<!--      <el-form-item>-->
<!--        <gateSelect-->
<!--          ref="itemIn"-->
<!--          @change="getItem"-->
<!--          :selectKey="'Id'"-->
<!--          :Direction="1"-->
<!--          placeholder="入口车道"-->
<!--          v-model="parkLotGateIdIn"-->
<!--          :isDisabled="false"-->
<!--        />-->
<!--      </el-form-item>-->
      <el-form-item>
        <gateSelect
          ref="itemOut"
          @change="getItem"
          :selectKey="'Id'"
          :Direction="2"
          placeholder="出口车道"
          v-model="outGateId"
          :isDisabled="false"
        />
      </el-form-item>
      <el-form-item>
        <el-select clearable v-model="isLeft" placeholder="停车状态">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select clearable v-model="PayType" placeholder="支付状态">
          <el-option
            v-for="item in payStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          @change="server"
          @input="server"
          v-model="secondaryConfirmRemark"
          placeholder="二次确认备注"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="server">
          <img src="@/assets/img/icon03.png" style="width: 14px; margin-right: 5px;"/>
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      height="400"
    >
      <el-table-column prop="passInPlateImage" label="凭证" align="center" width="100">
        <template slot-scope="scope">
          <el-image
            class="img"
            style="width: 79px; height: 44px;"
            lazy
            :src="scope.row.passPlateImage"
            fit="fill"
            :preview-src-list="scope.row.passPlateImageArr"
          >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot" style="line-height: 44px;">
              暂无图片
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="plateNumber"
        label="车牌"
        width="100"
      >
      </el-table-column>
      <el-table-column align="center" label="车类">
        <template slot-scope="scope">
<!--          <span>{{scope.row.isBillPack * 1 === 1 ? '包期车' : scope.row.carTypeStr}}</span>-->
          <span>{{scope.row.carTypeStr}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="parkStatus"
        label="停车状态"
        width="100"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="cameAt"
        label="入场时间"
        width="100"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="leftAt"
        label="出场时间"
        width="100"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="parkingLength"
        label="停车时长"
        width="100"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="paidAt"
        label="最后缴费时间"
        width="110"
      >
      </el-table-column>
<!--      <el-table-column align="center" prop="entranceName" label="入场车道">-->
<!--      </el-table-column>-->
      <el-table-column align="center" prop="exitName" label="出场车道">
      </el-table-column>
      <el-table-column align="center" prop="payableAmount" label="订单金额">
      </el-table-column>
      <el-table-column align="center" prop="moneyValuePaid" label="实收金额">
      </el-table-column>
      <el-table-column align="center" prop="secondaryConfirmRemark" label="二次确认备注" width="150px">
      </el-table-column>
      <el-table-column align="center" width="180" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleLookup(scope.row)">详情</el-button>
          <el-button type="primary" size="mini" @click="handleOut(scope.row)" v-if="scope.row.parkStatus !== '已出场'">手动出场</el-button>
        </template>
      </el-table-column>
    </el-table>
    <page-size ref="page" @pageChange="server" :isQueryAll="true" />
    <!-- 查看详情 -->
    <dialog-query-order v-if="detailDialogFormVisible" :showdialog.sync="detailDialogFormVisible" :orderId="tempOrder.id"></dialog-query-order>
    <dialog-handle-table-out
      title="出入口选择"
      v-if="showHandleTableOut"
      :showdialog.sync="showHandleTableOut"
      @getOutGateId="confirmOpenGate"
    ></dialog-handle-table-out>
  </div>
</template>

<script>
import { queryParkOrder } from "@/api/module/tenant";
import PageSize from "@/components/PageSize";
import parkMix from "@/minxs/parkLotId";
import gateSelect from "@/serviceComponents/gateSelect";
import dialogQueryOrder from "@/serviceComponents/dialogQueryOrder";
import dialogHandleTableOut from "@/serviceComponents/dialogHandleTableOut";
import { dialogTablePubSub } from "@/service/pubsub/index";
// import { orderPubSub, dialogTablePubSub } from "@/service/pubsub/index";
import { carPass } from "@/api/module/park";
import showdialog from "@/minxs/showdialog";

export default {
  data: () => ({
    plateNumber: "",
    isLeft: 2,
    tempOrder: {},
    detailDialogFormVisible: false,
    plateColorOptions: ['未知', '蓝色', '黄色', '白色', '黑色', '绿色', '新能源'],
    carSizeTable: [],
    tableData: [],
    loading: false,
    options: [
      {
        value: 1,
        label: '离场'
      },
      {
        value: 2,
        label: '未离场'
      },
      {
        value: 3,
        label: '待离场'
      },
    ],
    showHandleTableOut: false,
    pubOrderObj: {},
    payStatusOptions: [
      { value: 'notPay', label: '未支付' },
      { value: 'pay', label: '已支付' },
      { value: 'couponPay', label: '优惠券支付' },
      { value: 'freePay', label: '免费' }
    ],
    PayType: '',
    secondaryConfirmRemark: undefined,
  }),
  mixins: [parkMix, showdialog],
  mounted() {
    this.plateNumber = '';
    // this.outGateId = '';
    this.isLeft = 2;
    // this.server();
    // this.$refs.itemIn.server(true);
    this.$nextTick(() => {
      this.$refs.itemOut.server(true);
    });
  },
  watch: {
    outGateId() {
      this.$refs.itemOut.server(true);
    }
  },
  computed: {
    carSize: function () {
      let arr = this.carSizeTable.filter(v => {
        return v.Id === this.tempOrder.carSize
      });
      if (arr.length === 0) arr[0]= {Name: '不区分'};
      return arr[0].Name
    },
    outGateId: {
      get(){
        return this.$store.state.order.pubOutGateId;
      },
      set(v){
        this.$store.dispatch("SetPubOutGateId", v);
      }
    },
  },
  methods: {
    async server() {
      // console.log(this.outGateId);
      this.loading = true;
      const $page = this.$refs.page;
      let res = await queryParkOrder({
        Page: $page.current,
        PerPage: $page.pageSize,
        QueryAll: $page.QueryAll,
        ParkLotId: this.ParkLotId,
        orderNo: "",
        PlateNumber: this.plateNumber,
        OutGateId: this.outGateId,
        orderType: this.PayType === 'notPay' ? undefined : "全部",
        IsLimitDate: 1,
        Isleft: this.isLeft,
        GateQuery: true,
        PayType: this.PayType,
        SecondaryConfirmRemark: this.secondaryConfirmRemark,
        SentryBoxId: this.PayType === 'notPay' ? parseInt(sessionStorage.getItem('sentryId')) : undefined,
      });
      this.loading = false;
      if (res.state === "success") {
        this.tableData = res.data.map((v, i) => {
          v.Index = i;
          v.carSize = v.carSize > 0 ? v.carSize : 1;
          v.passPlateImage = v.passInPlateImage === '' ? v.passOutPlateImage : v.passInPlateImage;
          v.passPlateImageArr = [v.passPlateImage];
          return v
        });
        $page.total = res.pageInfo.Total;
      } else {
        this.tableData = [];
        $page.total = 0;
      }
    },
    // 查看详情
    handleLookup(row) {
      this.tempOrder.id = row.id;
      this.detailDialogFormVisible = true;
    },
    getItem(item) {
      this.$store.dispatch("SetPubOutGateId", item ? item.Id : '');
      // this.outGateId = item.Id
    },
    handleOut(data) {
      // console.log(data);
      this.pubOrderObj = {
        Id: data.id,
        order_id: data.id,
        park_lot_gate_id: data.outGateId,
        isWs: false,
        plateNumber: data.plateNumber,
        plateColor: data.plateColor,
        parkLotId: data.parkLotId,
      };
      // this.$store.dispatch("GetShowOrderDetail", true);
      if (data.outGateId === 0) {
        this.showHandleTableOut = true
      } else {
        this.$nextTick(() => {
          this.pubOrder()
        })
      }
      // this.$store.dispatch("SetShowGateSelect", data);
    },
    confirmOpenGate(str) {
      // console.log(str)
      this.pubOrderObj.park_lot_gate_id = str;
      this.pubOrder();
    },
    async pubOrder() {
      // console.log(this.pubOrderObj);
      // orderPubSub.publish(this.pubOrderObj);
      // this.$store.dispatch("GetWsOrderArr", this.pubOrderObj);
      let res = await carPass({
        ParkLotId: this.pubOrderObj.parkLotId,
        ParkLotGateId: this.pubOrderObj.park_lot_gate_id,
        PlateNumber: this.pubOrderObj.plateNumber,
        PlateColor: this.pubOrderObj.plateColor,
        Direction: 2,
        WaitTime: this.formatDateTime(new Date()),
      });
      if (res.state === "failed") {
        this.$message.error(res.message);
      }
      dialogTablePubSub.publish('close');
    },
  },
  components: {
    PageSize,
    gateSelect,
    dialogQueryOrder,
    dialogHandleTableOut,
  },
};
</script>

<style lang="scss" scoped>
.info {
  margin: 20px 0;
  h2 {
    margin: 12px 0;
  }
  p {
    margin: 5px 0;
    span {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin: 0 15px;
    }
  }
}
.img-list{
  span {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin: 0 15px;
  }
}
.single-img{
  margin: 10px 130px;
  width: 130px;
  height: 82px;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
